// extracted by mini-css-extract-plugin
export default {"container":"LoginScreen_container__IEp-G","logoType":"LoginScreen_logoType__CphDD"};